<template>
  <WeAppContainer view-name="home" />
</template>

<script>
export default {
  name: "Home",
};
</script>